import GetText from "node-gettext";
import { a as getLanguage } from "./chunks/locale-BQFSYg2g.mjs";
import "@nextcloud/router";
import "dompurify";
import "escape-html";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class GettextBuilder {
  constructor() {
    __publicField(this, "locale");
    __publicField(this, "translations", {});
    __publicField(this, "debug", false);
  }
  setLanguage(language) {
    this.locale = language;
    return this;
  }
  /** Try to detect locale from context with `en` as fallback value */
  detectLocale() {
    return this.setLanguage(getLanguage().replace("-", "_"));
  }
  addTranslation(language, data) {
    this.translations[language] = data;
    return this;
  }
  enableDebugMode() {
    this.debug = true;
    return this;
  }
  build() {
    return new GettextWrapper(this.locale || "en", this.translations, this.debug);
  }
}
class GettextWrapper {
  constructor(locale, data, debug) {
    __publicField(this, "gt");
    this.gt = new GetText({
      debug,
      sourceLocale: "en"
    });
    for (const key in data) {
      this.gt.addTranslations(key, "messages", data[key]);
    }
    this.gt.setLocale(locale);
  }
  subtitudePlaceholders(translated, vars) {
    return translated.replace(/{([^{}]*)}/g, (a, b) => {
      const r = vars[b];
      if (typeof r === "string" || typeof r === "number") {
        return r.toString();
      } else {
        return a;
      }
    });
  }
  /**
   * Get translated string (singular form), optionally with placeholders
   *
   * @param original original string to translate
   * @param placeholders map of placeholder key to value
   */
  gettext(original, placeholders = {}) {
    return this.subtitudePlaceholders(
      this.gt.gettext(original),
      placeholders
    );
  }
  /**
   * Get translated string with plural forms
   *
   * @param singular Singular text form
   * @param plural Plural text form to be used if `count` requires it
   * @param count The number to insert into the text
   * @param placeholders optional map of placeholder key to value
   */
  ngettext(singular, plural, count, placeholders = {}) {
    return this.subtitudePlaceholders(
      this.gt.ngettext(singular, plural, count).replace(/%n/g, count.toString()),
      placeholders
    );
  }
}
function getGettextBuilder() {
  return new GettextBuilder();
}
export {
  getGettextBuilder
};
